import { lazy, Suspense } from 'react';
import type { LottieComponentProps } from 'lottie-react';

const Lottie = lazy(() => import('lottie-react'));

export const LazyLottie = (props: LottieComponentProps) => (
  <Suspense
    fallback={
      <div style={{ width: props.style?.width ?? '100%', height: props.style?.height ?? '100%' }} />
    }
  >
    <Lottie {...props} />
  </Suspense>
);
